import { Container } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import React from "react";
import { Header } from "../layout-components/Header/header-component";

const useStyles = makeStyles()(() => ({
  headerContainer: {
    paddingLeft: "40px",
  },
}));

export const DefaultLayout: React.FunctionComponent<React.PropsWithChildren> = (props) => {
  const { classes } = useStyles();

  return (
    <>
      <div className={classes.headerContainer}>
        <Header />
      </div>
      <Container>
        <>{props.children}</>
      </Container>
    </>
  );
};

export default DefaultLayout;
